import user from "./user" // 账户相关
import customer from "./customer" // 客户
import chatbot from "./chatbot" // chatbot
import material from "./material" // 素材管理
import message from "./message" // 消息管理
import template from "./template" //模板管理
import home from "./home" //首页
import shortlink from "./shortlink" // 短链
import mobilePeng from "./peng" //撞库
export default {
    user,
    customer,
    chatbot,
    material,
    message,
    template,
    home,
    shortlink,
    mobilePeng
}